"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getCookie_1 = require("../../utils/cookies/getCookie");
const getSha256Hash_1 = require("../../utils/getSha256Hash");
const getWidgetQs_1 = require("../../utils/getWidgetQs");
const hbsptForm = window.hbspt.forms.create({
    region: "na1",
    portalId: "22398006",
    formId: "d1c57630-cc0e-4b1d-b5a2-02ed6cc43e50",
});
const cleanSeatsString = (seatsString) => {
    if (seatsString === "Just me") {
        return 1;
    }
    else
        return seatsString.split("-")[0].replace(",", "").replace("+", "");
};
hbsptForm.onFormSubmit(async ([form]) => {
    var _a, _b, _c;
    const { qsOrThrowFit } = (0, getWidgetQs_1.getWidgetQs)(form);
    try {
        const seats = (_a = qsOrThrowFit("select[name=company_size__custom_]")) === null || _a === void 0 ? void 0 : _a.value;
        const email = (_b = qsOrThrowFit("input[name=email]")) === null || _b === void 0 ? void 0 : _b.value;
        const dataLayerPayload = {
            event: "generate_lead",
            user_id: (0, getCookie_1.getCookie)("ajs_user_id"),
            affiliation: undefined,
            seats: cleanSeatsString(seats),
            email_address: email,
            email_address_hashed: await (0, getSha256Hash_1.getSha256Hash)(email),
        };
        (_c = window.dataLayer) === null || _c === void 0 ? void 0 : _c.push(dataLayerPayload);
    }
    catch (e) { }
});
